import { useState, useEffect } from 'react';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import BackToTopButton from '../../components/feature/BackToTopButton';
import CFIsHero from './components/CFIsHero';
import CFIsOverview from './components/CFIsOverview';
import CFIsStudentRoster from './components/CFIsStudentRoster';
import CFIsDebrief from './components/CFIsDebrief';
import CFIsReadinessReport from './components/CFIsReadinessReport';
import CFIsTestimonials from './components/CFIsTestimonials';
import CFIsPricing from './components/CFIsPricing';
import CFIsCTA from './components/CFIsCTA';

export default function CFIsPage() {
  const [scrolled, setScrolled] = useState(false);
  const [bannerVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A1628] text-white">
      <Navigation scrolled={scrolled} bannerVisible={bannerVisible} />
      
      <main className="pt-20">
        <CFIsHero />
        <CFIsOverview />
        <CFIsStudentRoster />
        <CFIsDebrief />
        <CFIsReadinessReport />
        <CFIsTestimonials />
        <CFIsPricing />
        <CFIsCTA />
      </main>

      <Footer />
      <BackToTopButton />
    </div>
  );
}